/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';

import NavigationService from 'services/NavigationService';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator';
import ManageUserLoginView from 'components/ManageUserLoginView/ManageUserLoginView';
import TableButton from 'components/TableButton';
import * as customerAccountsPermissions from 'permissions/customerAccounts';
import { actionDrawerStore } from 'services/ServiceRegistry';
import type { DataSource } from 'models/CustomerAccounts';

import createReportView from '../components/ReportView/ReportViewBase';
import type {
  ViewConfig,
  CellComponentProps,
  DataViewColumn,
} from '../components/ReportView/types';

const columns = (dataSource: DataSource): DataViewColumn[] =>
  [
    {
      columnName: 'customerId',
      title: 'general:customer_accounts.labels.id',
      flexBasis: 160,
      noFlexGrow: true,
    },
    {
      columnName: 'companyCode',
      title: 'general:customer_accounts.labels.company_code',
      flexBasis: 160,
      noFlexGrow: true,
    },
    {
      columnName: 'customerName',
      title: 'general:customer_accounts.labels.name',
      flexBasis: 1,
    },
    {
      columnName: 'assignedBrand',
      title: 'general:customer_accounts.labels.assigned_brand',
      flexBasis: 160,
      noFlexGrow: true,
    },
    {
      columnName: 'customerId',
      title: '',
      flexBasis: 80,
      noFlexGrow: true,
      disableSort: true,
      component: function EditButtonCell({ display, rowData: { companyCode } }) {
        const handleEditButtonClick = () => {
          setImmediate(() => {
            NavigationService.navigateTo(
              `customer-accounts/edit/${dataSource}/${display}/${companyCode}`
            );
          });
        };

        return (
          <TableButton
            label="general:actions.edit"
            iconHref="#icon-edit"
            onClick={handleEditButtonClick}
          />
        );
      },
    },
    {
      columnName: 'customerId',
      title: '',
      flexBasis: 100,
      noFlexGrow: true,
      disableSort: true,
      component: function DeleteButtonCell({ rowData }) {
        const handleDeleteButtonClick = () => {
          actionDrawerStore.openActionDrawer('deleteCustomerAccount', {
            customerAccountToDelete: rowData,
            dataSource,
          });
        };

        return (
          <TableButton
            label="general:actions.delete"
            iconHref="#icon-bin"
            onClick={handleDeleteButtonClick}
          />
        );
      },
    },
  ].filter(col => col);

const viewConfig: ViewConfig = {
  title: 'general:customer_accounts.title',
  codename: 'customer-accounts',
  type: 'TABBED',
  userFilterNamespace: 'customer-accounts',
  views: {
    d365: {
      title: 'general:customer_accounts.data_sources.er.title',
      filtersPathnameOverride: 'customer-account-management/er/filters',
      dataPathname: 'customer-account-management/er',
      apiType: 'SQL',
      columns: columns('er'),
    },
    perfect: {
      title: 'general:customer_accounts.data_sources.pf.title',
      filtersPathnameOverride: 'customer-account-management/pf/filters',
      dataPathname: 'customer-account-management/pf',
      apiType: 'SQL',
      columns: columns('pf'),
    },
  },
  buttons: [
    {
      icon: '#icon-add',
      label: 'general:actions.new',
      to: '/customer-accounts/create',
      permissions: customerAccountsPermissions.create,
    },
  ],
};

export default createReportView(viewConfig);
